import { render } from "./InvitationDocuments.vue?vue&type=template&id=073b18d6&scoped=true"
import script from "./InvitationDocuments.vue?vue&type=script&lang=js"
export * from "./InvitationDocuments.vue?vue&type=script&lang=js"

import "./InvitationDocuments.vue?vue&type=style&index=0&id=073b18d6&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073b18d6"]])

export default __exports__